<template lang="html">
  <div style="width: 100%; display: flex; justify-content: center;">
      <div
        id="g_id_onload"
        data-nonce=""
        data-auto_select="true"
        data-itp_support="true"
        data-context="use"
        data-ux_mode="popup"
        :data-client_id="clientId"
        :data-callback="callbackName"
        style="display: flex; justify-content: center; width: fit-content-box;"
      >
      </div>
      <div class="g_id_signin" data-type="standard"
        data-shape="rectangular"
        data-theme="outline"
        data-text="signin_with"
        data-size="large"
        data-logo_alignment="left"
        data-width="240"
        data-locale="en"
        data-button_type="standard"
      ></div>

      </div>
  </template>

<script>
// import { useAppStore } from "@/stores/app";
import axios from "axios";

export default {
  emits: ['showError'],
  name: 'GoogleSignIn',
  data() {
    return {
      clientId: process.env.VUE_CLIENT_ID_GSI,
      callbackName: "handleCredentialResponse",
      loading: false,
      snackbar: false,
      errorMsg: null,
    };
  },
  mounted() {
    // Load the Google Sign-In script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Define the callback function
    window.handleCredentialResponse = this.handleCredentialResponse;
  },
  methods: {
    handleCredentialResponse(response) {
      this.loading = true;
      this.snackbar = false;
      this.errorMsg = null;
      this.$store
        .dispatch('ssoGoogleAuth', { credential: response.credential})
        .then(() => {
          if (this.showDrawer) this.$store.commit("toggleDrawer");
          this.getDataUser();
        })
        .catch((message) => {
          if (message.response.data.statusCode === 403) {
            this.$emit('showError',message.response.data.message);
          } else {
            this.$emit('showError',message.response.data.message);
          }
        }).finally(() => {
          this.loading = false;
        });
    },
    getDataUser() {
      let token = localStorage.getItem('token');
      axios.get(process.env.VUE_APP_API + `/users/info`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          const email = localStorage.getItem('email_logout')
          let count = parseInt(localStorage.getItem(email));
          let user = JSON.parse(localStorage.getItem('user'));
          if (isNaN(count)) {
            localStorage.setItem(email, 1);
          } else {
            if (count < 2) {
              localStorage.setItem(user.email, count + 1);
            } else {
              localStorage.setItem("animationPointer", true);
            }
          }

          const redirect = this.$route.query.redirect;
          if (redirect) {
            this.$router.push(redirect)
          } else {
            if (res.data.data.role === 'super_user') {
              this.$router.push("my-request");
            } else {
              this.$router.push("/");
            }
          }
        })
        .catch(err => {
          if (err.response.status == 401) {
            return this.$router.push("/logout");
          }
        })
        .finally(() => (this.loading = false));
    },
  }
};
</script>

<style scoped>
.google-signin-btn {
  background-color: white !important;
  color: #3c4043 !important;
  font-family: 'Roboto', sans-serif;
  font-size: 14px !important;
  font-weight: 500 !important;
  letter-spacing: 0.25px;
  border-radius: 4px !important;
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.30), 0 1px 3px 1px rgba(60, 64, 67, 0.15) !important;
  transition: all 0.2s ease-in-out;
}

.google-signin-btn:hover {
  box-shadow: 0 1px 3px 0 rgba(60, 64, 67, 0.30), 0 4px 8px 3px rgba(60, 64, 67, 0.15) !important;
  background-color: #f8f9fa !important;
}

.google-signin-btn:focus {
  background-color: #f8f9fa !important;
}

.google-btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.google-icon {
  flex-shrink: 0;
}

.google-btn-text {
  font-size: 14px;
  font-weight: 500;
  color: #3c4043;
}

/* Loading state styling */
.google-signin-btn.v-btn--loading {
  background-color: #f8f9fa !important;
}
</style>
